export default {
  help: 'Veja o passo-a-passo para definir o ícone do site'
}
